import { defineComponent as _defineComponent } from 'vue'
type Props = {
  size?: number;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'MyFilterIcon',
  props: {
    size: { default: 24 }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})